import Vue from 'vue';
import Vuex from 'vuex';
import navMutations from '../mutations/navigation';


Vue.use(Vuex);

const store = {
    state: {
        navPoints: [{
                id: 0,
                label: 'text.wkbHelp',
                icon: 'help',
                spacer:true,
                call: function (t) {
                    t.SETWKBHELP(true);
                },
                show: false,
                order: 90
            }, {
                id: 1,
                label: 'text.startlist',
                icon: 'entrants',
                call: function (t) {
                    if (!t.$route.path.includes('/startlist'))
                        t.$router.push('/competition/events/event/startlist');
                },
                show: false,
                order: 30
            }, {
                id: 2,
                label: 'text.eventOverview',
                icon: 'overview',
                call: function (t) {
                    t.UNSETHEATDATA();
                    t.$router.push('/competition/events/');
                },
                show: false,
                order: 0
            }, {
                id: 3,
                label: 'text.logout',
                icon: 'logout',
                call: function (t) {
                    t.SETLANG({t: t, locale:t.LocaleFallBack});
                    t.LOGOUT();
                    t.HIDEALLNAVPOINT();
                    t.$router.push('dashboard/');
                },
                show: false,
                order: 100,
            }, {
                id: 4,
                label: 'text.startHeat',
                icon: 'start',
                call: function (t) {
                    t.SETHEATGROUPSTATUS({ state: 2 })
                },
                show: false,
                order: 10,
            }, {
                id: 5,
                label: 'text.stopHeat',
                icon: 'stop',
                call: function (t) {
                    if (confirm(t.$i18n.t('text.confirmHeatEnd'))) {
                        t.SETHEATGROUPSTATUS({ state: 3 })
                    }
                },
                show: false,
                order: 11
            }, {
                id: 6,
                label: 'text.poolMerge',
                icon: 'merge',
                call: function (t) {
                    t.REQUESTPOOLMERGEAVAILABLE(t);
                },
                show: false,
                order: 85
            }, {
                id: 7,
                label: 'text.settings',
                icon: 'settings',
                call: function (t) {
                    if (!t.$route.path.includes('/settings'))
                        t.$router.push('/competition/events/settings')
                },
                show: true,
                order: 95
            }, {
                id: 8,
                label: 'text.resultEdit',
                icon: 'entrie',
                call: function (t) {
                    if (!t.$route.path.includes('/editResult'))
                        t.$router.push('/competition/events/event/editResult/')
                },
                show: true,
                order: 31
            },],
    },
    mutations: {
        [navMutations.SHOWNAVPOINT]: (state, ids) => {
            if (ids.length != 0) {
                ids.forEach(x => {
                    const np = state.navPoints.find(y => y.id == x);
                    np.show = true;
                });
            }
        },
        [navMutations.HIDENAVPOINT]: (state, ids) => {

            if (ids.length != 0) {
                ids.forEach(x => {
                    const np = state.navPoints.find(y => y.id == x);
                    np.show = false;
                });
            }
        },
        [navMutations.HIDEALLNAVPOINT]: (state) => {
            state.navPoints.forEach(x => x.show = false);
        },
    },
    getters: {
        NavPoints: state => state.navPoints.filter(x => x.show === true).sort((a, b) => {
            if (a.order < b.order) return -1
            if (a.order > b.order) return 1
            return 0
        }),
        NavLength: state => (state.navPoints.filter(x => x.show === true)).length,
    }

};

export default store;